import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { colors } from "healthex-common/colors";
import styled from "styled-components";
import { FlexColumnDiv } from "./common.styles";
export const OrgSelectionEmailSubtitle = styled.p `
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.31px;
    color: ${colors.black_lighter};
    margin: 0;
`;
export const OrgSelectionNotYouLink = styled.span `
    color: ${colors.blue_main};
    text-decoration: underline;
    cursor: pointer;
`;
export const OrgSelectionContainer = styled(FlexColumnDiv) `
    gap: 24px;
    width: 100%;
`;
export const OrgDescriptiveText = styled.p `
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.31px;
    color: ${colors.black_light};
    margin: 0;
`;
export const OrgList = styled(FlexColumnDiv) `
    gap: 8px;
    width: 100%;
`;
export const OrgCard = styled.button `
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    background: white;
    border: 1px solid ${colors.black_12};
    border-radius: 4px;
    padding: 8px;
    height: 100px;
    width: 100%;
    cursor: pointer;
    text-align: left;
    box-sizing: border-box;

    &:hover {
        background: #f5f5f5;
    }
`;
export const OrgInfo = styled(FlexColumnDiv) `
    gap: 16px;
    align-items: flex-start;
    justify-content: center;
    flex: 1;
    min-width: 0;
`;
export const OrgLogo = styled.img `
    max-height: 32px;
    max-width: 160px;
    object-fit: contain;
`;
export const OrgName = styled.span `
    font-size: 19px;
    color: ${colors.black_main};
    letter-spacing: 0.14px;
`;
export const OrgCardArrow = styled(ArrowForwardIcon) `
    font-size: 24px !important;
    color: ${colors.black_main};
    flex-shrink: 0;
`;
